module.exports = __webpack_public_path__ + "img/1.ad052ff1.png";